export const iconFontAwesomeMusicVideoWaveSquare = (
	<i className="fa-solid fa-wave-square"></i>
);
